import { jsx as u } from "react/jsx-runtime";
import { c as d } from "react/compiler-runtime";
import { Menu as x } from "@mui/material";
import { styles as M } from "./DateTimeSelect.style.js";
const g = (f) => {
  const e = d(20);
  let t, o, r, l, s, n, i;
  e[0] !== f ? ({
    anchorEl: t,
    open: i,
    onClose: n,
    children: o,
    menuId: r,
    menuWidth: s,
    ...l
  } = f, e[0] = f, e[1] = t, e[2] = o, e[3] = r, e[4] = l, e[5] = s, e[6] = n, e[7] = i) : (t = e[1], o = e[2], r = e[3], l = e[4], s = e[5], n = e[6], i = e[7]);
  let c, p;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = {
    vertical: "bottom",
    horizontal: "center"
  }, p = {
    vertical: "top",
    horizontal: "center"
  }, e[8] = c, e[9] = p) : (c = e[8], p = e[9]);
  const h = s ? `${s}px` : "auto";
  let m;
  e[10] !== h ? (m = {
    paper: {
      sx: {
        ...M.dateTimeSelectorMenuStyle["& .MuiPaper-root"],
        width: h
      }
    }
  }, e[10] = h, e[11] = m) : m = e[11];
  let a;
  return e[12] !== t || e[13] !== o || e[14] !== r || e[15] !== l || e[16] !== n || e[17] !== i || e[18] !== m ? (a = /* @__PURE__ */ u(x, { id: r, anchorEl: t, open: i, onClose: n, anchorOrigin: c, transformOrigin: p, slotProps: m, ...l, children: o }), e[12] = t, e[13] = o, e[14] = r, e[15] = l, e[16] = n, e[17] = i, e[18] = m, e[19] = a) : a = e[19], a;
};
export {
  g as AnchorDropdownMenu
};
